import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type { IApiUpdateInvitationResponseBody } from '../InvitationsApi.types';
import { useApi } from '~/lib/api/useApi';
import { organizationUsersQueryKeyFactory } from '../../Organizations/hooks/useOrganizationUsersQuery';
import { invitationQueryKeyFactory } from './useInvitationQuery';
import { organizationInvitationsQueryKeyFactory } from './useOrganizationInvitationsQuery';

export type IUseCancelInvitationMutationValues = {
  organizationId: string;
  invitationId: string;
};

export const useCancelInvitationMutation = (): UseMutationResult<
  IApiUpdateInvitationResponseBody,
  unknown,
  IUseCancelInvitationMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseCancelInvitationMutationValues) =>
      api.invitations.cancel(values.invitationId),
    onSuccess: (_, values) =>
      Promise.all(
        [
          { queryKey: organizationInvitationsQueryKeyFactory(values) },
          { queryKey: invitationQueryKeyFactory(values) },
          { queryKey: organizationUsersQueryKeyFactory(values) },
        ].map((filters) => queryClient.invalidateQueries(filters)),
      ),
  });
};
